import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/Button';
import { VIEW_COLUMNS, type ViewColumn } from './columns';

interface ColumnPickerProps {
  columns: ViewColumn[];
  onChange: (columns: ViewColumn[]) => void;
}

/**
 * Die Spaltenwahl.
 *
 * Die Reihenfolge folgt `VIEW_COLUMNS` und nicht der Klickreihenfolge: Eine
 * Liste, deren Spalten je nach Anklickreihenfolge woanders stehen, laesst
 * sich nicht wiedererkennen.
 */
export function ColumnPicker({ columns, onChange }: ColumnPickerProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className="snippet-picker">
      <Button
        variant="ghost"
        aria-expanded={open}
        onClick={() => {
          setOpen((value) => !value);
        }}
      >
        {t('columns.choose')}
      </Button>

      {open ? (
        <div className="snippet-picker__panel">
          <ul className="snippet-picker__list">
            {VIEW_COLUMNS.map((column) => (
              <li key={column}>
                <label className="field__checkbox">
                  <input
                    type="checkbox"
                    checked={columns.includes(column)}
                    // Die letzte Spalte laesst sich nicht abwaehlen -- eine
                    // Tabelle ohne Spalten ist keine Ansicht, sondern ein
                    // Fehler, der wie eine leere Liste aussieht.
                    disabled={columns.length === 1 && columns.includes(column)}
                    onChange={(event) => {
                      onChange(
                        event.target.checked
                          ? VIEW_COLUMNS.filter(
                              (candidate) => candidate === column || columns.includes(candidate),
                            )
                          : columns.filter((candidate) => candidate !== column),
                      );
                    }}
                  />
                  {t(`columns.${column}`)}
                </label>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
